import React from "react";
import Loading from "../../../components/Loading";
import ErrorMessage from "../../../components/Error";
import QuestionTreeRenderer from "../../questionnaire/QuestionTreeRenderer";
import {
  QuestionGroupWithRelations,
  QuestionWithRelations,
} from "../../../../../api/src/types";

interface QuestionContentProps {
  isLoading: boolean;
  error: unknown;
  question: QuestionWithRelations | undefined;
  groups: QuestionGroupWithRelations[] | undefined;
}

export const QuestionContent: React.FC<QuestionContentProps> = ({
  isLoading,
  error,
  question,
  groups,
}) => {
  if (isLoading) {
    return <Loading />;
  }
  if (error || !question) {
    return (
      <ErrorMessage>
        Could not load questions. Refresh the page and if the problem persists
        use the chat bubble to reach out to our support team.
      </ErrorMessage>
    );
  }
  return (
    <QuestionTreeRenderer
      shouldValidateQuestionnaireSection={true}
      question={question}
      sectionGroupsData={groups ?? []}
    />
  );
};
